import React, { memo } from "react";

// eslint-disable-next-line react/display-name
const Owner = memo(({
                      availableOwner,
                      handleChange,
                    }) => (
  <div className="form-group form-group-sm">
    <div className="input-group input-group-sm">
      <div className="input-group-prepend w-25">
        <span className="input-group-text w-100">{availableOwner.fullname}</span>
      </div>
      <input
        className="form-control" type="number"
        value={availableOwner.percent ? availableOwner.percent : 0}
        max={100}
        min={0}
        onChange={(ev) => {
          handleChange({
            id: availableOwner.id,
            fullname: availableOwner.fullname,
            percent: ev.target.value
          });
        }}
      />
      <div className="input-group-append">
        <span className="input-group-text">%</span>
      </div>
    </div>
  </div>
));

export default Owner;



// WEBPACK FOOTER //
// ./src/views/pages/chargers/stations/Owner.js